import { openLogin } from '@/utils/loginModal'
import { isLoggedIn, getMember } from '@/utils/auth'
import { onLoginSuccess, offLoginSuccess } from '@/utils/loginModal'
import { onProfileUpdated, offProfileUpdated } from '@/utils/userMenu'

export default {
  mounted() {
    onLoginSuccess(this.syncAuthState)
    onProfileUpdated(this.syncAuthState)
  },
  beforeDestroy() {
    offLoginSuccess(this.syncAuthState)
    offProfileUpdated(this.syncAuthState)
  },
  methods: {
    goLogin() {
      openLogin(this.$route.fullPath)
    },
    goRegister() {
      this.goLogin()
    },
    syncAuthState() {
      this.loggedIn = isLoggedIn()
      this.userInfo = getMember() || { nickName: '访客' }
      if (typeof this.refreshQuotaBalance === 'function') {
        this.refreshQuotaBalance()
      } else if (typeof this.loadUserData === 'function') {
        this.loadUserData()
      }
    }
  }
}
